if (!customElements.get('featured-banner-slider')) {
    class FeaturedBannerSlider extends HTMLElement {
        constructor() {
            super();
            this.mediaQuery = window.matchMedia('(min-width: 769px)');

            this.banner = this.querySelector('.featured-banner__slider');
            this.allItems = [...this.querySelectorAll('.featured-banner__slider > .gtm-item')];
            this.arrowLeftButton = this.querySelector('.featured-banner__arrow--left');
            this.arrowRightButton = this.querySelector('.featured-banner__arrow--right');

            this.currentIndex = 0;
            this.maxIndex = this.mediaQuery.matches? this.allItems.length - 2 : this.allItems.length - 1;

            this.handleResize = this.debounce(this.handleResize, 200);
            this.handleClick = this.handleClick.bind(this);
            this.handleMediaQueryChange = this.handleMediaQueryChange.bind(this);
        }

        debounce(fn, delay = 200) {
            let timeout;

            return (...args) => {
                clearTimeout(timeout);

                timeout = setTimeout(() => {
                    fn.apply(this, args);
                }, delay);
            };
        }

        connectedCallback() {
            this.mediaQuery.addEventListener('change', this.handleMediaQueryChange);
            this.addEventListener('click', this.handleClick);
            window.addEventListener('resize', this.handleResize);

            this.updateDimensions();
            this.updateArrows();
        }

        handleClick(e) {
            if (!e.target.closest('.featured-banner__arrow--left, .featured-banner__arrow--right')) return;

            if (e.target.closest('.featured-banner__arrow--left')) {
                this.handleScroll('left');
            } else {
                this.handleScroll('right');
            }
        }

        handleScroll(dir) {

            if (dir === 'left' && this.currentIndex > 0) {
                this.currentIndex--;
            }

            if (dir === 'right' && this.currentIndex < this.maxIndex) {
                this.currentIndex++;
            }

            this.banner.style.transform = `translateX(calc(-${this.currentIndex} * ${this.singleItemWidth}px))`;
            this.updateArrows();
        }

        handleResize() {
            this.currentIndex = 0;
            this.scrollLeft = 0;
            this.banner.style.transform = 'translateX(0)';
            this.updateDimensions();
            this.updateArrows();
        }

        handleMediaQueryChange() {
            if (this.mediaQuery.matches) {
                this.maxIndex = this.allItems.length - 2;
            } else {
                this.maxIndex = this.allItems.length - 1;
            }
        }

        updateDimensions() {
            this.gapProp = parseInt(getComputedStyle(this.banner).getPropertyValue('gap')) || 0;
            this.featuredBannerTotalWidth = this.offsetWidth || 0;
            this.singleItemWidth = this.allItems[0]?.offsetWidth + this.gapProp || 0;
        }

        updateArrows() {
            this.arrowLeftButton.disabled = this.currentIndex === 0;
            this.arrowRightButton.disabled = this.currentIndex === this.maxIndex;
        }

        disconnectedCallback() {
            this.removeEventListener('click', this.handleClick);
            window.removeEventListener('resize', this.handleResize);
            this.mediaQuery.removeEventListener('change', this.handleMediaQueryChange);
        }
    }

    customElements.define('featured-banner-slider', FeaturedBannerSlider);
}
